<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <CategoryCreatePageHeader
      :categoryName="categoryName"
      :handleCreate="handleCreateCategoryInstance"
    />
    <CategoryForm
      :categoryName="categoryName"
      :formData="createFormData"
      :componentId="componentId"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import CategoryForm from "@/components/ComponentModule/CategoryComponent/CategoryForm";
import CategoryCreatePageHeader from "@/components/ComponentModule/CategoryComponent/CategoryCreatePageHeader";

export default {
  name: "CategoryCreatePage",
  components: {
    BannerNotification,
    CategoryCreatePageHeader,
    CategoryForm
  },
  data() {
    return {
      createFormData: {
        category_page: {
          attributes: {
            abi_cat_content_block: "yes",
            abi_cat_content_block_instance: "abi_content_block",
            abi_cat_tagline: "",
            abi_cat_desc: "yes",
            abi_cat_desc_faqs: "yes",
            abi_cat_desc_range: "yes",
            abi_cat_desc_overview: "yes",
            abi_cat_desc_assistance: "yes",
            abi_cat_ribbon_custom: "no",
            abi_cat_ribbon_arr: "",
            abi_cat_intro_toggle: "no",
            abi_cat_intro_shortcode: ""
          },
          instance_name: ""
        },
        abi_content_block: { attributes: {}, instance_name: "" },
        overview_ctb: { attributes: {}, instance_name: "" },
        range_ctb: { attributes: {}, instance_name: "" },
        assistance_ctb: { attributes: {}, instance_name: "" },
        faqs_ctb: { attributes: {}, instance_name: "" },
        category_faq: { attributes: {}, instance_name: "" }
      }
    };
  },
  props: {
    categoryName: {
      type: String,
      required: true
    }
  },
  mounted() {
    // fetch category name info
    if (!this.getAllComponent.length) {
      this.$store.dispatch(Actions.FETCH_ALL_COMPONENT, {
        region: this.getRegion,
        hardRefresh: false
      });
    } else {
      if (!Object.keys(this.categoryAllAttributes).length) {
        this.$store.dispatch(Actions.FETCH_CATEGORY_ATTRIBUTES, {
          region: this.getRegion,
          componentId: this.componentId
        });
      }
    }
    this.setInstanceName();
  },
  computed: {
    componentId() {
      if (this.getAllComponent.find((item) => item.name === "abi_category")) {
        return this.getAllComponent.find((item) => item.name === "abi_category")
          .id;
      } else {
        return null;
      }
    },
    ...mapGetters([
      "getAllComponent",
      "categoryInstance",
      "categoryAllAttributes",
      "getRegion",
      "currentUser"
    ])
  },
  watch: {
    componentId() {
      if (this.componentId) {
        this.$store.dispatch(Actions.FETCH_CATEGORY_ATTRIBUTES, {
          region: this.getRegion,
          componentId: this.componentId
        });
      }
    }
  },
  methods: {
    setInstanceName() {
      // set default value for create form
      const fields = ["overview", "range", "faqs", "assistance"];
      fields.forEach((item) => {
        this.createFormData[`${item}_ctb`][
          "instance_name"
        ] = `${item}_${this.categoryName}`;
      });
      this.createFormData["abi_content_block"]["instance_name"] =
        this.categoryName;
      this.createFormData["category_page"]["instance_name"] = this.categoryName;
      this.createFormData["category_faq"]["instance_name"] = this.categoryName;
    },
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    },
    async handleCreateCategoryInstance() {
      this.$store
        .dispatch(Actions.CREATE_CATEGORY_INSTANCE, {
          region: this.getRegion,
          formData: this.createFormData,
          getComponentId: this.getComponentId,
          user: this.currentUser.email
        })
        .then(() => this.$router.back());
    }
  }
};
</script>
